import React from 'react';
import Bargains from 'app/BargainWidget/Bargains/Bargains';
import { BargainContextProvider } from 'app/BargainWidget/context/BargainContext';
import ToastContainer from 'app/BargainWidget/Main/ToastContainer';

const Main = () => {
  return (
    <BargainContextProvider>
      <style>{window?.['bargain']?.config?.widgetSettings?.customCss?.replaceAll('\n', '').replaceAll('"', '')}</style>
      <Bargains />
      <ToastContainer />
    </BargainContextProvider>
  );
};

export default Main;
